import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowLeft,
  faAnglesRight,
  faAnglesLeft,
} from "@fortawesome/free-solid-svg-icons";

const Pagination = ({
  canPreviousPage,
  canNextPage,
  pageOptions,
  pageCount,
  gotoPage,
  nextPage,
  previousPage,
  setPageSize,
  pageIndex,
  pageSize,
}) => {
  return (
    <div className="pagination d-flex align-items-center justify-content-between gap-3">
      <div className="pagination-section1 d-flex flex-row align-items-center gap-3">
        <div
          dir="rtl"
          className="pagination-section1-arrows d-flex flex-row align-items-center justify-content-between gap-1"
        >
          <button
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
            style={!canPreviousPage ? { cursor: "no-drop" } : {}}
          >
            <FontAwesomeIcon icon={faAnglesRight} />
          </button>
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            style={!canPreviousPage ? { cursor: "no-drop" } : {}}
          >
            <FontAwesomeIcon icon={faArrowRight} />
          </button>

          <span dir="ltr">
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>

          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            style={!canNextPage ? { cursor: "no-drop" } : {}}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>

          <button
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
            style={!canNextPage ? { cursor: "no-drop" } : {}}
          >
            <FontAwesomeIcon icon={faAnglesLeft} />
          </button>
        </div>
      </div>

      <div className="pagination-section2 d-flex flex-row align-items-center gap-3">
        {/* <span>
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "100px" }}
          />
        </span> */}
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {pageSize}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;
